// Default search values for filtering messages
export const searchValues = { title: "", isSended: "", date: "" };

// Mapping of Excel header cells to message properties
export const excelHeaderCellsName = {
  المعرف: "id",
  "نص الرسالة": "body",
  "تم الإرسال": "isSent",
  "تاريخ الإرسال": "sendingDate",
  "اسم المستلم": "reipientDisplayName",
  "رقم هاتف المستلم": "recipientPhoneNumber",
};
